<div class="data-loader" style="height:100vh!important">
  <div class="loader-circle" [ngStyle]="{'top.px': (commonService.gsh/3)}">
    <div class="loader-line-mask">
      <div class="loader-line"></div>
    </div>
    <div class="content"> <img src="assets/images/yourstore_logo_only.svg" alt="logo"> </div>
  </div>
</div>